export const FETCH_IVR_NDR_CONFIRMATION_CHARGES_REQUEST = "FETCH_IVR_NDR_CONFIRMATION_CHARGES_REQUEST";
export const FETCH_IVR_NDR_CONFIRMATION_CHARGES_SUCCESS = "FETCH_IVR_NDR_CONFIRMATION_CHARGES_SUCCESS";
export const FETCH_IVR_NDR_CONFIRMATION_CHARGES_FAILURE = "FETCH_IVR_NDR_CONFIRMATION_CHARGES_FAILURE";
export const FETCH_IVR_NDR_CONFIRMATION_CHARGES_RESET = "FETCH_IVR_NDR_CONFIRMATION_CHARGES_RESET";
export const fetchIvrNdrConfirmationChargesRequest = (payload) => ({
    type: FETCH_IVR_NDR_CONFIRMATION_CHARGES_REQUEST,
    payload,
});
export const fetchIvrNdrConfirmationChargesSuccess = (payload) => ({
    type: FETCH_IVR_NDR_CONFIRMATION_CHARGES_SUCCESS,
    payload,
});
export const fetchIvrNdrConfirmationChargesFailure = (payload) => ({
    type: FETCH_IVR_NDR_CONFIRMATION_CHARGES_FAILURE,
    payload,
});
export const fetchIvrNdrConfirmationChargesReset = () => ({
    type: FETCH_IVR_NDR_CONFIRMATION_CHARGES_RESET,
});
